import React from 'react';
import PropTypes from 'prop-types';

import {Divider} from 'reakit'
import {Container} from "../../components/Base";

import Notifications from './Notifications'
import Interests from "./Interests";


const StudentSettings = props => {
	const {
		school, profile, updateInterests, updateRequestNotification,
	} = props;

	let myInterests = [] 		// eslint-disable-line no-empty-pattern
	if (profile !== null || profile.interests) {
		myInterests = profile.interests
	}
	let interests = [];
	if (school && school.interests) {
		interests = school.interests
	}
	return (
		<Container px={3}>

			<Interests
				interests={interests}
				selected={myInterests}
				handleUpdate={updateInterests}/>

			<Divider/>

			<Notifications
				updateRequestNotification={updateRequestNotification}
			/>
		</Container>
	);
};

StudentSettings.propTypes = {
	school: PropTypes.object,
	profile: PropTypes.object,
	updateInterests: PropTypes.func,
	updateRequestNotification: PropTypes.func,


};

export default StudentSettings;
